import { render, staticRenderFns } from "./CardBackground.vue?vue&type=template&id=8ec166ae&scoped=true"
import script from "./CardBackground.vue?vue&type=script&lang=js"
export * from "./CardBackground.vue?vue&type=script&lang=js"
import style0 from "./CardBackground.vue?vue&type=style&index=0&id=8ec166ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec166ae",
  null
  
)

export default component.exports